import { NODE_ENV, GO_BASE_API } from '@com/config/env'
import { getHostByEnv } from '../../../config/apiHost'
import { getLocalStorage } from '@com/utils/storage'

export const playTurboHostList = {
  development: '//mindwork.dev.com:9628',
  test: process.env.PT_BASE_URL
    ? process.env.PT_BASE_URL
    : '//mindworks-creative-test.mintegral.com',
  production: 'https://app.playturbo.com',
  prerelease: 'https://app-pre.playturbo.com',
}

export const playTurboNextHostList = {
  development: '//mindwork.dev.com:5173',
  test: `${
    process.env.PT_BASE_URL
      ? process.env.PT_BASE_URL
      : '//mindworks-creative-test.mintegral.com'
  }/next`,
  production: 'https://app.playturbo.com/next',
  prerelease: 'https://app-pre.playturbo.com/next',
}

export const portalNextHostList = {
  development: '//fe.dev.com:5174',
  test: `//playable-portal-test2.mintegral.com/next`,
  production: '//playable-portal.mintegral.com/next',
  prerelease: '//playable-portal-pre.mintegral.com/next',
}

// TODO: 把 host 提取到环境变量中
export const V2ApiHostList = {
  development: GO_BASE_API,
  test: GO_BASE_API,
  production: getHostByEnv('production'),
  prerelease: getHostByEnv('prerelease'),
}

// 如果当前的域名是 cn 域名，则后端接口也要做调调整
const getActiveHost = (host) => {
  // 获取当前的 URL
  const currentUrl = window.location.href

  // 创建一个 URL 对象
  const url = new URL(currentUrl)

  if (url.hostname.endsWith('playturbo.cn')) {
    return host.replace('playturbo.com', 'playturbo.cn')
  }
  return host
}

const PT_HOST_KEY = 'MWS_GO_BASE_API'
export const v2Host = getActiveHost(
  getLocalStorage(PT_HOST_KEY) || V2ApiHostList[NODE_ENV],
)

export const automationPlatformHostList = {
  // 开发环境与测试环境都是用测试服务器
  development: '//video-auto-test.mintegral.com',
  test: '//video-auto-test.mintegral.com',
  production: '//mws-video-auto.mintegral.com',
  prerelease: '//mws-video-auto.mintegral.com',
}
export const automationPlatformHost = automationPlatformHostList[NODE_ENV]

const getWsDevHost = (url) => {
  if (!url) {
    throw new Error('url是必传参数')
  }
  if (url.indexOf('http') === 0) {
    return url.replace('http', 'ws')
  } else if (url.indexOf('//') === 0) {
    return `ws:${url}`
  } else if (url.indexOf('/') === 0) {
    // 如果是相对路径
    return `ws://${location.host}${url}`
  }
  return url
}
const wsHostList = {
  development: GO_BASE_API ? getWsDevHost(GO_BASE_API) : '',
  test: GO_BASE_API ? getWsDevHost(GO_BASE_API) : '',
  production: getHostByEnv('production').replace('https', 'wss'),
  prerelease: getHostByEnv('prerelease').replace('https', 'wss'),
}
export const wsHost = wsHostList[NODE_ENV]

// 官网
const websiteHostList = {
  development: {
    cn: '//localhost:8011',
    com: '//localhost:8011',
  },
  test: {
    cn: '//mw-test.mindworks-creative.com',
    com: '//mw-test.mindworks-creative.com',
  },
  production: {
    cn: '//www.playturbo.cn',
    com: '//www.playturbo.com',
  },
  prerelease: {
    cn: '//pre.playturbo.cn',
    com: '//pre.playturbo.com',
  },
}

const isCN = window.location.host.indexOf('.cn') > -1

export const websiteHost = websiteHostList[NODE_ENV][isCN ? 'cn' : 'com']
export const portalNextHost = portalNextHostList[NODE_ENV]
export const playTurboNextHost = playTurboNextHostList[NODE_ENV]
